

export const imgLink = "https://image.tmdb.org/t/p/w500/";
export const emptyPoster =
  "https://cdn-icons-png.flaticon.com/512/44/44991.png";
export const emptyCompany =
  "https://i.pinimg.com/736x/d9/d1/2a/d9d12aac0e13cac391f27654e7567ffd.jpg";
export const emptyTextInfo =
  "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui voluptates nihil modi reiciendis ipsam. Soluta repellendus adipisci, autem voluptatem blanditiis fuga ad, expedita eveniet, ullam quos corrupti delectus provident excepturi";

export const emptyUserImg = 'https://as1.ftcdn.net/v2/jpg/03/53/11/00/1000_F_353110097_nbpmfn9iHlxef4EDIhXB1tdTD0lcWhG9.jpg'
 

export const BASE_URL = "https://api.themoviedb.org";
export const KEY = "ee3e9c5f4ba904ebcf317d566e2eec32";

// console.log(import.meta.env.VITE_API_KEY);
